import { ReactNode } from 'react'
import { IntercomProvider as _IntercomProvider } from 'react-use-intercom'
import { useIsFlowpage } from '../../../hooks/useIsFlowpage/useIsFlowpage'

interface IntercomProviderProps {
  children: ReactNode
}

export function IntercomProvider(props: IntercomProviderProps): JSX.Element {
  const isFlowpage = useIsFlowpage()
  return (
    <_IntercomProvider
      appId={process.env.INTERCOM_APP_ID}
      shouldInitialize={!isFlowpage}
      {...props}
    />
  )
}
//
